// extracted by mini-css-extract-plugin
module.exports = {"createNewAttribute":"GroupAttributeForm_createNewAttribute_toAWS"};